import bold from "./bold";
import italic from "./italic";
import underline from "./underline";
import lists from "./lists";
import code from "./code";
import typography from "./typography";
import link from "./link";

export default [bold(), italic(), underline(), lists(), code(), typography(), link()];
